import FormWithDescription from '../../FormWithDescription';
import DomainStatusCheck from './DomainStatusCheck';
import AddDomainWizard from './AddDomainWizard';
import { useState } from 'react';
import Button from '@mui/material/Button';

export default function DomainWizard(props) {
  const [openAddDomainWizard, setOpenAddDomainWizard] = useState(false);

  const { plan, setValue, blog } = props;
  return (
    <>
      {blog.domain ? (
        <DomainStatusCheck {...props} />
      ) : (
        <FormWithDescription
          title="Add your domain"
          description={`Make your blog available on a domain like example.com`}
        >
          {plan === 'trial' ? (
            <>
              You need to{' '}
              <span
                onClick={() => {
                  setValue(4);
                }}
                className="tw-cursor-pointer tw-text-primary-500 dark:tw-text-primary-300 hover:tw-underline"
              >
                upgrade to a paid plan
              </span>{' '}
              to add your own domain.
            </>
          ) : (
            <>
              <Button
                variant="contained"
                onClick={() => setOpenAddDomainWizard(true)}
              >
                Set up your domain
              </Button>
              <AddDomainWizard
                {...props}
                open={openAddDomainWizard}
                setOpen={setOpenAddDomainWizard}
              />
            </>
          )}
        </FormWithDescription>
      )}
    </>
  );
}
